module.exports = __webpack_public_path__ + "static/media/our-first-add.6234b6a5.jpg";